"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Symbol("Backbuffer");
//# sourceMappingURL=Backbuffer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gl-react/lib/Backbuffer.js
// module id = 75
// module chunks = 0